( function($) {

	var app = {

        updateGallery: function() {

          var get_selected = jQuery('.ip-sd-gallery-container.default-gallery').attr('data-selected');

          if( jQuery('.ip-sd-gallery-container.variant-gallery.variant-' + get_selected ).length ) {

            jQuery('.ip-sd-gallery-container.default-gallery').addClass('hidden');
            
          } else {

            jQuery('.ip-sd-gallery-container.default-gallery').removeClass('hidden');
          }
          
        },

		initGallerySlider: function(){
			$('.default-gallery .ip-sd-gallery-slide').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				infinite: true,
				autoplay: false,
				autoplaySpeed: 3000,
				asNavFor: '.default-gallery .ip-sd-gallery-thumb-slide',
			 });

			$('.default-gallery .ip-sd-gallery-thumb-slide').not('.slick-initialized').slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3000,
				asNavFor: '.default-gallery .ip-sd-gallery-slide',
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 992,
						settings: {
						slidesToShow: 4,
						slidesToScroll: 1
						}
					}
				]
			 });
		},

		initSizeButtons: function(){
			$('.ip-sd-product-btn').on('click', function(e){
				e.preventDefault();
				$('.ip-sd-product-btn').not('disabled').removeClass('active');
				$(this).not('disabled').addClass('active');
			});
		},

        updatePrice: function() {

            $('#product-select-option-0').change(function(){

                var get_price = $('#product-select option:selected').attr('data-price');

                var get_variant = $('#product-select option:selected').val();

                // $('h4.product__price.price.js-product-price').html( get_price );

                $('.product__price.price.js-product-price').html( get_price );

                jQuery('.ip-sd-gallery-container:not(.hidden)').addClass('hidden');

                if( jQuery('.ip-sd-gallery-container.variant-gallery.variant-' + get_variant ).length ) {
      
                  jQuery('.ip-sd-gallery-container.variant-gallery.variant-' + get_variant ).removeClass('hidden');
                  
                } else {

                  jQuery('.ip-sd-gallery-container.default-gallery').removeClass('hidden');
                }
            });
        }
	}

	
	$(document).ready( function() {

        app.updateGallery();
		app.initGallerySlider();
		app.initSizeButtons();
	});
	
	$(window).on('load', function(){

        app.updatePrice();
	});

    /*
    document.addEventListener('DOMContentLoaded', function() {
      document.getElementById('add-to-cart-form').addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent the form from submitting the traditional way
      
        var formData = new FormData(
          id: document.getElementById('product-variant-id').value,
          quantity: document.getElementById('quantity').value 
        );
      
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(response => response.json())
        .then(data => {
          console.log('Product added to cart:', data);
          alert('Product added to cart!');
          // Optionally update cart UI or redirect
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        });
      });
    });
  */

})(jQuery);